import React from "react";
import { Box } from "@mui/system";
import {
  Stack,
  Container,
  Fade,
  Typography,
} from "@mui/material";
import theme, { DCDashboardContainer } from "../../assets/theme/theme";
import O1EB1Folder from "./O1EB1Folder";
import ViewUploadDocsTitle from "../ViewUploadDocsTitle";
import Spinner from "../Spinner";
import { useO1EB1DocumentsContext } from "../../contexts/O1EB1DocumentsContext";

export interface Props { }
// DashboardGallery
// after the documents are fetched it shows either the folder view or empty state to upload documents
const O1EB1DashboardGallery: React.FC<Props> = () => {
  const { O1EB1AutoFolders, O1EB1ManualFolders, initalizedDocumentsAndFolders } = useO1EB1DocumentsContext();

  if (!initalizedDocumentsAndFolders) return <Spinner />;

  return (
    <Stack
      mt={2}
      pb={10}
      borderRadius={5}
      bgcolor={theme.palette.common.white}
      sx={{ minHeight: "calc(100% - 64px)" }}
    >
      <>
        <Box>
          <Container maxWidth={false} disableGutters>
            <Box sx={{ p: 4, pb: 0 }} className="document-gallery-title">
              <ViewUploadDocsTitle />
            </Box>
            <DCDashboardContainer className="auto-generated-main">
              {O1EB1AutoFolders.length > 0 && (
                <Box mb={6}>
                  <Typography variant="h4" fontSize={18} fontWeight={500} mb={6}>
                    Main Documents
                  </Typography>
                  <Box
                    className="auto-generated-model"
                    display="grid"
                    gridTemplateColumns="repeat(auto-fill,minmax(220px,1fr))"
                  >
                    {O1EB1AutoFolders.map((item, i) => {
                      return (
                        <Fade
                          className="auto-generated-folder"
                          in={!!item}
                          key={i}
                          {...(!!item ? { timeout: 150 * i + 1 } : {})}
                        >
                          <Box
                          // display="flex"
                          // alignItems="baseline"
                          // justifyContent="center"
                          // px={1}
                          // key={"create-folder"}
                          >
                            <Box mx="auto" minHeight={196} className="auto-generated-folder-contains">
                              <O1EB1Folder folder={item} />
                            </Box>
                          </Box>
                        </Fade>
                      );
                    })}
                  </Box>
                </Box>
              )}
              {O1EB1ManualFolders.length > 0 && (
                <Box mb={6}>
                  <Typography variant="h4" fontSize={18} fontWeight={500} mb={6}>
                    Supporting Documents
                  </Typography>
                  <Box
                    className="auto-generated-model"
                    display="grid"
                    gridTemplateColumns="repeat(auto-fill,minmax(220px,1fr))"
                  >
                    {O1EB1ManualFolders.map((item, i) => {
                      return (
                        <Fade
                          className="auto-generated-folder"
                          in={!!item}
                          key={i}
                          {...(!!item ? { timeout: 150 * i + 1 } : {})}
                        >
                          <Box
                            // display="flex"
                            // alignItems="baseline"
                            // justifyContent="center"
                            // px={1}
                            // key={"create-folder"}
                          >
                            <Box mx="auto" minHeight={196} className="auto-generated-folder-contains">
                              <O1EB1Folder folder={item} />
                            </Box>
                          </Box>
                        </Fade>
                      );
                    })}
                  </Box>
                </Box>
              )}
              {/* <CustomFolderSection/> */}
            </DCDashboardContainer>
          </Container>
        </Box>
      </>
    </Stack>
  );
};

export default O1EB1DashboardGallery;
